module.exports = "/assets/d5b2215f0d43d26de15a2889e54cd25c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/V2.png
// module id = 3030
// module chunks = 0